import { render, staticRenderFns } from "./ProviderRegistration.vue?vue&type=template&id=9121a718&scoped=true&"
import script from "./ProviderRegistration.vue?vue&type=script&lang=ts&"
export * from "./ProviderRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderRegistration.vue?vue&type=style&index=0&id=9121a718&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9121a718",
  null
  
)

export default component.exports